import { graphql } from "react-relay";

export const load_lesson_stages = graphql`
  query LoadLessonStagesQuery($schoolId: ID, $startingYear: Int!, $block: Int!, $skip: Boolean!) {
    lessonStages(schoolId: $schoolId, startingYear: $startingYear, block: $block, first: 20)
      @skip(if: $skip)
      @connection(key: "LoadLessonStages_query_lessonStages") {
      __id
      edges {
        node {
          id
          stage
          lessonDuration
          lessonType
          costPerLesson
        }
      }
    }
  }
`;
